import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DomUtilsService {
  /**
   * Find drawer element in the DOM
   */
  findDrawerElement(drawerIndex: number): HTMLElement | null {
    try {
      const allDrawers = document.querySelectorAll('.ant-drawer');
      if (
        !allDrawers ||
        allDrawers.length === 0 ||
        drawerIndex >= allDrawers.length
      ) {
        return null;
      }

      return allDrawers[drawerIndex] as HTMLElement;
    } catch (error) {
      console.error(`Error finding drawer element: ${error}`);
      return null;
    }
  }

  /**
   * Find the most recently opened drawer
   */
  findLastDrawerElement(): HTMLElement | null {
    try {
      const allDrawers = document.querySelectorAll('.ant-drawer');
      if (!allDrawers || allDrawers.length === 0) {
        return null;
      }

      return allDrawers[allDrawers.length - 1] as HTMLElement;
    } catch (error) {
      console.error(`Error finding last drawer element: ${error}`);
      return null;
    }
  }

  /**
   * Updates DOM title element directly
   */
  updateDrawerTitle(drawer: HTMLElement, newTitle: string): boolean {
    if (!drawer) return false;

    try {
      const titleElement = drawer.querySelector('.ant-drawer-title');
      if (titleElement) {
        titleElement.textContent = newTitle;
        return true;
      }
      return false;
    } catch (error) {
      console.error(`Error updating drawer title: ${error}`);
      return false;
    }
  }
}
